import { PayloadAction } from "@reduxjs/toolkit";
import { EmployeesState } from "../../models/EmployeesState";
import { GetTeachersListPayload } from "../../payload/GetTeachersList/GetTeachersListPayload";

const getTeachersListFetch = (state: EmployeesState, action: PayloadAction<GetTeachersListPayload>) => {
    state.isLoading = true;
}

export default getTeachersListFetch;